import styled from 'styled-components';

import { StyledProps } from '@/shared/lib/interfaces/styled-props.interface';
import { Box } from '@/shared/ui/box';
import { Link } from '@/shared/ui/link';

export const Wrapper = styled(Box)``;

export const BreadcrumbLink = styled(Link)<StyledProps>`
	align-items: center;
	gap: 0;
	border-radius: 2px;
	pointer-events: ${({ active }) => active && 'none'};

	& > p {
		padding: 4px 8px;
	}
`;
